import config from '../../config'

export const safeHostedUrl = value => {
  try {
    const url = new URL(value)
    return url.protocol === 'https:' &&
      ['developers.decidir.com', 'live.decidir.com'].includes(url.hostname) &&
      !url.port && !url.username && !url.password && !url.search && !url.hash &&
      /^\/web\/checkout\/[^/]+$/.test(url.pathname) ? url.href : null
  } catch (_) {
    return null
  }
}

const toBearerAuthorization = token => {
  const value = typeof token === 'string' ? token.trim() : ''
  if (!value) return ''
  const rawToken = value.replace(/^Bearer(?:\s+|$)/i, '').trim()
  return rawToken ? `Bearer ${rawToken}` : ''
}

export const createHostedLinksModule = (apiUrl, request = (...args) => fetch(...args)) => {
  const call = async (token, path, options = {}) => {
    const response = await request(`${apiUrl}/payway/hosted-links-2${path}`, {
      ...options,
      headers: { 'Content-Type': 'application/json', Authorization: toBearerAuthorization(token) }
    })
    const data = await response.json()
    if (!response.ok || data.exito !== 1) throw new Error('No se pudo completar la solicitud. Verifique sus permisos o intente más tarde.')
    return data
  }
  return {
    namespaced: true,
    state: () => ({ companies: [], authorized: false }),
    mutations: {
      setAccess (state, companies) {
        state.companies = companies
        state.authorized = true
      },
      clearAccess (state) {
        state.companies = []
        state.authorized = false
      }
    },
    actions: {
      async loadAccess ({ rootState, commit }) {
        commit('clearAccess')
        const data = await call(rootState.token, '/access')
        if (data.permission !== '/links-de-pago-2' || !Array.isArray(data.companies)) {
          throw new Error('No se pudo verificar el acceso a Links de Pago 2.')
        }
        const companies = data.companies.filter(company =>
          Number.isInteger(company.empresa_id) && company.empresa_id > 0 &&
          typeof company.name === 'string'
        )
        commit('setAccess', companies)
        return companies
      },
      async listLinks ({ rootState }, { empresa_id, offset = 0 }) {
        const query = new URLSearchParams({ empresa_id, offset, limit: 25 })
        const data = await call(rootState.token, `?${query}`)
        if (!Array.isArray(data.data)) throw new Error('La respuesta del listado no es válida.')
        return data.data
      },
      async createLink ({ rootState }, { empresa_id, amount, concept }) {
        const data = await call(rootState.token, '', {
          method: 'POST', body: JSON.stringify({ empresa_id, amount, concept })
        })
        if (!data.data || !safeHostedUrl(data.data.payment_link)) {
          throw new Error('No se recibió un enlace de pago válido.')
        }
        return data.data
      }
    }
  }
}

export default createHostedLinksModule(config.API_URL)
